module.exports = __webpack_public_path__ + "img/close_bold.93dfe413.svg";